import { GET_CAR, GET_CARFACILTIES,GET_ADDCAR_FAILED,GET_ADDCAR_REQUESTED, GET_ADDCAR_SUCCESS, GET_DELETECAR_FAILED, GET_DELETECAR_REQUESTED, GET_DELETECAR_SUCCESS, GET_UPDATECAR_FAILED, GET_UPDATECAR_REQUESTED, GET_UPDATECAR_SUCCESS, GET_FACILITIES_FAILED, GET_FACILITIES_REQUESTED, GET_FACILITIES_SUCCESS } from "resources/actionTypes";


const initialState = {
  userCar: [],
  loading: false,
  error: null,
};

const initialCarFacilities = {
  userCarFacilities: [],
  loading:false,
  error: null
}

const initialStateAdd = {
  userAddCar: [],
  loading: false,
  error: null,
};
const initialStateUpdate = {
  userUpdateCar: [],
  loading: false,
  error: null
}
const initialStateDelete = {
  userDeleteCar: [],
  loading: false,
  error: null
}
const initialStateFacilities = {
  userFacilities: [],
  loading: false,
  error: null,
};

export function userCar(state = initialState, action) {
  switch (action.type) {
    case GET_CAR.GET_CAR_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CAR.GET_CAR_SUCCESS:
      return {
        ...state,
        loading: false,
        userCar: action.userCar,
      };
    case GET_CAR.GET_CAR_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
      case GET_CAR.GET_CAR_CLEAR:
        return {
          ...state,
          loading: false,
          userCar: [],
        };
    default:
      return state;
  }
}

export function userCarFacilities(state = initialCarFacilities, action) {
  switch (action.type) {
    case GET_CARFACILTIES.GET_CARFACILTIES_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CARFACILTIES.GET_CARFACILTIES_SUCCESS:
      return {
        ...state,
        loading: false,
        userCarFacilities: action.userCarFacilities,
      };
    case GET_CARFACILTIES.GET_CARFACILTIES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userAddCar(state = initialStateAdd, action) {
  switch (action.type) {
    case GET_ADDCAR_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDCAR_SUCCESS:
      return {
        ...state,
        loading: false,
        userAddCar: action.userAddCar,
      };
    case GET_ADDCAR_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userUpdateCar(state = initialStateUpdate, action) {
  switch (action.type) {
    case GET_UPDATECAR_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATECAR_SUCCESS:
      return {
        ...state,
        loading: false,
        userUpdateCar: action.userUpdateCar,
      };
    case GET_UPDATECAR_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userDeleteCar(state = initialStateDelete, action) {
  switch (action.type) {
    case GET_DELETECAR_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_DELETECAR_SUCCESS:
      return {
        ...state,
        loading: false,
        userDeleteCar: action.userDeleteCar,
      };
    case GET_DELETECAR_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userFacilities(state = initialStateFacilities, action) {
  switch (action.type) {
    case GET_FACILITIES_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_FACILITIES_SUCCESS:
      return {
        ...state,
        loading: false,
        userFacilities: action.userFacilities,
      };
    case GET_FACILITIES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}